var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCourier = function SvgIconCourier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 32a5 5 0 1 1-10 0 5 5 0 0 1 10 0zm22 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M18 9h22l7 13v11h-5.1a5 5 0 1 0-9.8 0H19.9a5 5 0 1 0-9.848-.279c-.023.098-.04.191-.052.279H1V22l10-3 7-10z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeWidth: 2,
    d: "M20 32a5 5 0 1 1-10 0 5 5 0 0 1 10 0zm22 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
  }));
};
export default SvgIconCourier;